<template>
  <app-layout title="Billing">
    <PageTitle :headerTitle="title"> </PageTitle>
    <div class="max-w-7xl mx-auto sm:px-6 lg:px-8">
      <div class="row">
        <div class="col-lg-9 col-9 text-left">
           <h5 class="">Your Billings</h5>
           <h6 class="text-left">(Select a billing id to proceed)</h6>
            <br> 
        </div>

        <div class="col-lg-3 col-3 text-right">
          <jet-nav-link href="/tenants/create" class="hover:no-underline">
            <div
              class="bg-blue-500 p-2 hover:cursor-pointer rounded-full shadow"
              style="display: inline-block"
            >
              <i
                class="
                  fas
                  fa-plus
                  text-white text-xl
                  d-flex
                  justify-content-center
                "
              ></i>
            </div>
          </jet-nav-link>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-12 col-12 text-left">
          <div class="grid grid-cols-5 gap-2"> 
            <!-- <div class="border border-gray-200 bg-white w-48 h-48 p-2 rounded-lg" v-for="(d, b) in tenantData" :key="b"> -->
            <div class="border border-gray-200 bg-white w-48 h-36 p-2 rounded-lg">

            
              <div class="no-decoration text-black hover:text-black" > 
              <!-- fetch and show the billing ids -->
            <span class="font-weight-bold ">Billing</span> <br>
            <span class="text-xs">GST No. : 123456789123456</span> <br>
            <span class="text-xs">PAN No. : 1234567890</span> <br>
            <span class="text-xs">Email : abc@aruvaa.com</span><br>
            
            <a v-bind:href="'/subscription'+combinedQuery" class="mt-1 bg-green-500 rounded text-white text-xs text-center hover:no-underline pl-2 pr-2" >Use this
                account</a> <br>
            <button class="bg-green-500 rounded text-white invisible text-xs text-center hover:no-underline pl-2 pr-2" data-toggle="modal" data-target="#billingEditModal">Edit</button>&nbsp;<button class="bg-red-500 invisible rounded text-white text-xs text-center hover:no-underline pl-2 pr-2">Delete</button>            
            </div>
          </div>
        </div>
          
        </div>
      </div>
    </div>    
  </app-layout>
</template>
<style>
    .noselect {
        -webkit-touch-callout: none;
        /* iOS Safari */
        -webkit-user-select: none;
        /* Safari */
        -khtml-user-select: none;
        /* Konqueror HTML */
        -moz-user-select: none;
        /* Firefox */
        -ms-user-select: none;
        /* Internet Explorer/Edge */
        user-select: none;
        /* Non-prefixed version, currently
                                  supported by Chrome and Opera */
    }

    .img-company {
        width: 50px;
        height: 50px;
    }

    .no-decoration{
      text-decoration: none;
    }

    .no-decoration:hover{
      text-decoration: none;
    }



    .organisations-container {
        width: 50% !important;
        background: var(--white);
    }

    .ul-add-organisation {
        background-color: var(--blue);
    }


    .btn-submit {
        background-color: var(--blue);
    }
    
    </style>

<script>
import AppLayout from "@/Layouts/AppLayout.vue";
import Welcome from "@/Jetstream/Welcome.vue";
import PageTitle from "@/Layouts/PageTitle.vue";
import JetNavLink from '@/Jetstream/NavLink.vue'


export default {
  props: ["sessions"],

  components: {
    AppLayout,
    Welcome,
    PageTitle,
    JetNavLink,

  },
  data() {
    return {
      tenantData: null,
      productData:null,
      title: "Organisations",
      productId:"",
      organisationId:"",
      combinedQuery:"",
    };
  },
  methods: {
    getOrganisation() {
       let urlParams = new URLSearchParams(window.location.search);
       console.log("organisation_id : "+urlParams.get('organisation_id')); // organisation_id
       console.log(urlParams.get('product_id')); // "product_id"
      this.productId=urlParams.get('product_id');
      this.organisationId=urlParams.get('organisation_id');
      this.combinedQuery="?product_id="+this.productId+"&organisation_id="+this.organisationId;
      axios.get("tenants/list").then((response) => {
        this.tenantData = response.data.results.data;
      });
    },
  },
  mounted() {
    this.getOrganisation();
  },
};
</script>
